import api from "@helpers/api";
import { materialWriteBody } from "./materialWriteBody";

/**
 * Update an existing material
 * @param {UpdateMaterialDTO} materialDTO - Material data transfer object
 * @returns {Promise<{success: boolean, data?: Object, error?: string}>}
 */
export async function updateMaterial(materialDTO) {
    try {
        const payload = materialDTO.toPayload();
        const materialId = materialDTO.getId();
        const body = materialWriteBody(payload);
        const { data } = await api.patch(`material/${materialId}`, body);

        if (data.id) {
            return { success: true, data };
        }

        return {
            success: false,
            error: 'Não foi possível atualizar o material'
        };
    } catch (error) {
        console.error('Error updating material:', error);

        return {
            success: false,
            error: 'Um erro ocorreu ao salvar o material, confira o arquivo inserido e tente novamente'
        };
    }
}
